/* eslint-disable */
import { useState, useEffect, useRef } from "react";
import { Grid, GridColumn, GridNoRecords } from "@progress/kendo-react-grid";
import * as API from "../../framework/API/api";
import { DateCell, DateOnlyCell, LocalDateTimeColumn } from "../../framework/forms/helpercomponents/CustomGridCells/DateCell";
import { LookupCell } from "../../framework/forms/helpercomponents/CustomGridCells/LookupCell";
import { ImageCell } from "../../framework/forms/helpercomponents/CustomGridCells/ImageCell";
import { COLUMNSTYPE, ENTITYNAME, MODULE, FILEURL, SOCKET_EVENTS, SOCKET_ACTION, LOGEVENT, MEDIACATEGORIES, LOCALSTORAGE_KEY, MEDIA_TRANSMISSION, TOAST_TYPES } from "../../framework/constant/constant";
import { useLocation, useNavigate } from "react-router-dom";
import { MenuCommandCell } from "../../framework/forms/helpercomponents/CustomGridCells/MenuCommandCell ";
import { TimeCell } from "../../framework/forms/helpercomponents/CustomGridCells/TimeCell";
import { collectionMenuModel } from "../../framework/forms/helpercomponents/contextMenu/menus/collectionMenuModel";
import { ArrayCell } from "../../framework/forms/helpercomponents/CustomGridCells/ArrayCell";
import { CheckboxCell } from "../../framework/forms/helpercomponents/CustomGridCells/CheckBoxCell";
import { HrefCell } from "../../framework/forms/helpercomponents/CustomGridCells/HrefCell";
import { useTranslation } from "../../locale/useTranslation";
import BackRoundButton from "../../framework/forms/helpercomponents/buttons/BackRoundButton";
import RefreshButton from "../../framework/forms/helpercomponents/buttons/RefreshButton";
import { EnumCell } from "../../framework/forms/helpercomponents/CustomGridCells/EnumCell";
import { PlatformCell, arrayEnumCell } from "../../framework/forms/helpercomponents/CustomGridCells/PlatformCell";
import MyStatusCell from "../../components/MyStatusCell";
import { IconCell } from "../../framework/forms/helpercomponents/CustomGridCells/IconCell";
import { getter } from "@progress/kendo-data-query";
import { Loader } from "../../framework/forms/helpercomponents/Loader";
import { MyToggleButton } from "../../framework/forms/helpercomponents/CustomGridCells/MyToggleButton";
import { utility } from "../../framework/utility/utilityProvider";
import socket from "../../framework/socket/socket";
import { DataHelper } from "../../framework/helper/DataHelper";
import { GlobalMediaFilterTemplate } from "./GlobalMediaFilterTemplate";
import PreferenceRoundButton from "../../framework/forms/helpercomponents/buttons/PreferenceRoundButton";
import { UserPreference } from "../userPreference/UserPreference";
import RoundButton from "../../framework/forms/helpercomponents/buttons/RoundButton";
import castTypeCell from "../../framework/forms/helpercomponents/CustomGridCells/CastTypeCell";
import ToastNotification from "../../components/ToastNotification";

const SELECTED_FIELD = "selected";
const DATA_ITEM_KEY = "_id";
const idGetter = getter(DATA_ITEM_KEY);

export const GlobalSearchMediaCollection = (props) => {
  //possible props
  let page_take = props.page_take ?? 50;
  let showCommandCell = props.showCommandCell ?? true;
  let showTitle = props.showTitle ?? true;
  let gridRowRender = props.gridRowRender;
  let filterable = props.filterable ?? false;
  let sortable = props.sortable ?? true;
  let isPageable = props.isPageable ?? true;
  let sort = props.sort ?? { SID: 1 };
  let customColumns = props.customColumns ?? [];
  let openNewEditForm = props.openNewEditForm ?? false;
  let myTitle = props.title ?? "";
  let myMenuModel = props.menuModel ?? collectionMenuModel;
  let entityName = props.entityname;
  let module = props?.module;
  let showPreferenceButton = props.showPreferenceButton ?? true;
  let showExport = props.showExport ?? true;
  const preferenceColumnENntityName = props.preferenceEntityName && props.preferenceEntityName.length > 0 ? props.preferenceEntityName : entityName;

  const urlParams = new URLSearchParams(location?.search ?? "");
  const paramQuery = {
    curPage: parseInt(urlParams.get('page')) || 1,
    index: parseInt(urlParams.get('index')) || 0
  }

  // example custome columns[]
  const [gridData, setGridData] = useState([]);
  const [total, setTotal] = useState(1);
  const [openForm, setOpenForm] = useState(false);
  const [editItem] = useState({ SID: 1 });
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [dataColumns, setDataColumns] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [showArchived, setShowArchived] = useState(false);
  const [hideArchive] = useState(false);
  const [filterDataItem, setFilterDataItem] = useState({});
  const [filterTemplate, setFilterTemplate] = useState([]);
  const initialSort = { field: Object.keys(sort)[0], dir: sort[Object.keys(sort)[0]] == 1 ? "asc" : "desc" }
  const [gridSort, setGridSort] = useState([initialSort]);
  const [filterPopupOpen, setFilterPopupOpen] = useState(true);
  const [isFilterCleared, setIsFilterCleared] = useState(true);
  const [selectedTemplate, setSelectedTemplate] = useState({});
  const [showPreferences, setShowPreferences] = useState(false);

  const gridRef = useRef(null);

  const [page, setPage] = useState({
    skip: (paramQuery.curPage - 1) * page_take,
    take: page_take,
  });

  //only to get wherestatement from href cell
  const loc = useLocation();
  const lang = useTranslation();

  let href = loc.state ? loc.state.href : false;
  if (href) {
    wherestatement = loc.state.wherestatement;
  }

  useEffect(() => {
    setShowArchived(false);
    setIsLoading(true);
    setFilterTemplate([]);
    setGridSort([initialSort]);
    setPage({ skip: (paramQuery.curPage - 1) * page_take, take: page_take });
  }, []);

  useEffect(() => {
    if (gridRef.current && paramQuery.index >= 0) {
      let updateIndex = paramQuery.index > page_take ? paramQuery.index - ((paramQuery.curPage - 1) * page_take) : paramQuery.index;
      const gridElement = gridRef.current.element || gridRef.current.wrapper || gridRef.current;
      const contentArea = gridElement.querySelector('.k-grid-content');
      if (!contentArea) return;
      const rows = contentArea.querySelectorAll('tr');
      if (updateIndex < rows.length) {
        const targetRow = rows[updateIndex];
        const rowOffsetTop = targetRow.offsetTop;
        const contentAreaHeight = contentArea.clientHeight;
        const scrollPosition = rowOffsetTop - contentAreaHeight / 2 + targetRow.clientHeight / 2;
        contentArea.scrollTo({
          top: scrollPosition,
          behavior: 'smooth',
        });
      }
    }
  }, [paramQuery.index, gridData]);

  // Search 
  useEffect(() => {
    if (searchText == null) return;
    let sortEvent = gridSort[0] ?? initialSort;
    if (searchText != "") {
      const timeOut = setTimeout(() => {
        setIsLoading(true);
        loaddata({ per_page: page.take, current_page: 1, orderby: sortEvent.field, direction: sortEvent.dir }, searchText, showArchived, filterTemplate);
      }, 700);
      return () => clearTimeout(timeOut);
    } else {
      setIsLoading(true);
      setPage({ skip: (paramQuery.curPage - 1) * page_take, take: page_take });
      loaddata({ per_page: page_take, current_page: paramQuery.curPage, orderby: sortEvent.field, direction: sortEvent.dir }, searchText, showArchived, filterTemplate);
    }
  }, [searchText]);

  const loaddata = async (pagination, searchText, archive, filters, channelFilter) => {

    let channel = channelFilter ? channelFilter : filterDataItem?.Channel && filterDataItem?.Channel?.length != 0 ? filterDataItem.Channel.map((item) => item.SID) : []

    if (filters.length == 0 && searchText == "") {
      setIsLoading(false);
      setGridData([]);
      setTotal(1)
      return;
    };

    if (props.gridColumns) {
      setDataColumns(props.gridColumns);
      setGridData(props.gridData);
      setIsLoading(false);
    } else {
      try {

        let currentUserId = utility.getValue(LOCALSTORAGE_KEY.user_id);
        let columns = await API.getFormData(preferenceColumnENntityName, currentUserId);
        let finalSort = pagination.direction ? { [pagination.orderby ?? 'SID']: pagination.direction == 'asc' ? 1 : -1 } : sort;
        let json = await API.getEntitiesSearchWithMediaGlobal(
          { query: ["MediaCategory.isLong", "=", true], page: pagination.current_page, perPage: pagination.per_page, archive: archive, sort: finalSort },
          columns,
          searchText,
          filters,
          props.mediaCategory,
          channel
        );
        console.log(json.data);
        setGridData(json.data);
        setTotal(json.pagination.total);
        //if custmoe colum is coming from compemnent level then no need  a column from Server API
        customColumns.length > 0
          ? setDataColumns(customColumns)
          : setDataColumns(columns);

        // console.log(columns)
        setIsLoading(false);
      } catch (error) {
        console.log("error", error);
        setIsLoading(false);
      }
    }
  };

  const enterEdit = (item) => {
    console.log(item);

    let param = item.AssetId && item.AssetId.length > 0 && item.AssetId.includes("/") ? item.SID : item.AssetId;
    let state = {
      copy: item.copy ? true : false,
      quickEdit: item.quickEdit ? true : false,
      prevPath: loc.pathname,
      paths: [loc.pathname],
      pagination: ""
    }

    let tournamentId = item?.Tournament?._id;

    //FINAL ROUTE
    let route = `${param}`
    if (tournamentId) {
      route = `/home/Tournament/${tournamentId}`
    } else if (loc.pathname.includes("SearchProgram")) {
      let mediaCategory = utility.getKeyByValue(MEDIACATEGORIES, item.MediaCategory.SID);
      let newPath = loc.pathname.replace("SearchProgram", mediaCategory)
      route = `${newPath}/${param}`
    }

    // navigate(route, { state: state });
    window.open(route, { state: state })

  };

  //onSubmit from EDIRFORM
  const handleSubmit = async (dataItem, dataToSave) => {
    //if datatosave is null then dataitem is datasave
    dataToSave = dataToSave == null ? dataItem : dataToSave;
    let isDuplicate = await utility.checkDuplicate(props.entityname, dataToSave);
    if (!isDuplicate) {
      setOpenForm(true);
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.entry_already_exist_try_with_different_values_collection_error_message });
      return;
    }
    let res = await API.saveData(props.entityname, dataToSave);
    console.log(res);
    if (!res.success) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
      return;
    }
    socket()?.emit(SOCKET_EVENTS.onSocketData, { action: SOCKET_ACTION.DELETE_LOCAL_STORAGE_KEY, module: MODULE.ALL, data: props.entityname })
    utility.deleteLocalStorageItem(props.entityname)
    //to load grid with new data
    loaddata({ per_page: page_take, current_page: 1 }, searchText, showArchived, filterTemplate);
    setOpenForm(false);
  };

  const handleCancelEdit = () => {
    setOpenForm(false);
  };

  const handleArchive = async (dataItem) => {
    if (entityName == ENTITYNAME.Series || entityName == ENTITYNAME.Season) {
      var resArchiveUpdated = await API.onChangeArchiveInSeriesSeason({
        _id: dataItem._id,
        archive: !dataItem.Archive,
        entityName: entityName
      })
    } else {
      var resArchiveUpdated = await API.saveData(entityName, {
        ...dataItem,
        Archive: !dataItem.Archive
      })
    }

    if (resArchiveUpdated.success) {
      console.log(`Archive is been updated to ${!dataItem.Archive}`);
      let logData = { event: !dataItem.Archive ? LOGEVENT.ARCHIVE : LOGEVENT.UNARCHIVE, module: module, data: { ...dataItem, Archive: !dataItem.Archive }, message: resArchiveUpdated.message };
      API.SaveLogs(logData);
      let sortEvent = gridSort[0] ?? initialSort;
      let current_page = page.skip / page.take + 1;
      loaddata({ per_page: page_take, current_page: !dataItem.Archive ? current_page : 1, orderby: sortEvent.field, direction: sortEvent.dir }, searchText, showArchived, filterTemplate);
      socket()?.emit(SOCKET_EVENTS.onSocketData, { action: SOCKET_ACTION.DELETE_LOCAL_STORAGE_KEY, module: MODULE.ALL, data: props.entityname })
      utility.deleteLocalStorageItem(entityName);
    } else {
      console.log(resArchiveUpdated.message);
    }
  }

  const onExportSegmentation = async (item) => {
    let payload = [{ _id: item._id, mediaCategorySID: item?.MediaCategory?.SID }];
    let res = await API.getSegmentationDataExport(payload);
    if (res.success) {
      if (res.dataLength == 0) {
        ToastNotification({ type: TOAST_TYPES.INFO, title: lang.info_message_title, message: lang.no_data_found_for_selected_filter_error_message });
        return;
      }
      else {
        window.open(FILEURL().BASEURL + 'downloadReport/' + res.fileName)
        ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: 'Successfully Exported!' });
      }
    }
    else {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
    }
  };

  const onExportSegmentationData = (item) => {
    onExportSegmentation(item);
  };

  const MyCommandCell = (props) => (

    <MenuCommandCell
      {...props}
      history={history}
      enterEdit={enterEdit}
      cancelEdit={handleCancelEdit}
      onSubmit={handleSubmit}
      item={editItem}
      quickEdit={onEnterQuickEdit}
      dataColumns={dataColumns}
      onArchive={handleArchive}
      myMenuModel={myMenuModel}
      module={module}
      openNewEditForm={openNewEditForm}
      onExportSegmentationData={onExportSegmentationData}
    />
  );

  const MyCustomToggleButton = (props) => (
    <MyToggleButton
      {...props}
      entityName={entityName}
      size={"small"}
    />
  );

  const MyDatalookupCell = (props) => (
    <LookupCell {...props} dataColumns={dataColumns} />
  );

  const Mystatuscell = (props) => (
    <div>
      <MyStatusCell title={props.dataItem.CurrentStatus} tileBackColor="#72eda9" />
    </div>
  )

  const MyTransmissionCell = (props) => {

    let color = "grey";

    if (props.dataItem.Transmission == MEDIA_TRANSMISSION.READY) {
      color = "#67AE6E";
    }

    return (
      <div>
        <MyStatusCell title={utility.getKeyByValue(MEDIA_TRANSMISSION, props.dataItem.Transmission) ?? "HOLD"} tileBackColor={color} />
      </div>
    )

  }

  const pageChange = async (e) => {
    let current_page = e.page.skip / e.page.take + 1;
    let sortEvent = gridSort[0] ?? initialSort;
    // if page change then route change as well 
    const url = new URL(window.location);
    url.searchParams.set('page', current_page);
    url.searchParams.set('index', 0);
    window.history.pushState({}, '', url);
    await loaddata({ per_page: e.page.take, current_page: current_page, orderby: sortEvent.field, direction: sortEvent.dir }, searchText, showArchived, filterTemplate);
    setPage(e.page);
  };

  const onArchiveClick = () => {
    setShowArchived(!showArchived);
    let sortEvent = gridSort[0] ?? initialSort;
    if (!showArchived) {
      loaddata({ per_page: page.take, current_page: 1, orderby: sortEvent.field, direction: sortEvent.dir }, searchText, true, filterTemplate);
    } else {
      let current_page = page.skip / page.take + 1;
      loaddata({ per_page: page.take, current_page: current_page, orderby: sortEvent.field, direction: sortEvent.dir }, searchText, false, filterTemplate);
    }
    cancelSelectedItem();
  }

  const refreshCollection = () => {
    setIsLoading(true);
    setPage({ skip: 0, take: page.take });
    loaddata({ per_page: page.take, current_page: 1, orderby: "SID", direction: "asc" }, searchText, showArchived, filterTemplate);
    setGridSort([initialSort]);
  }

  const toGetFilteredData = (data) => {

    console.log("HERE COLLECTION");
    console.log(data);
    setIsLoading(true);
    setFilterDataItem(data);
    setSearchText(data?.SearchText ?? "");
    //Filter Query
    let finalFilterQuery = DataHelper.getMediaFilterQuery(data, entityName);;
    let channelFilter = data?.Channel && data?.Channel?.length != 0 ? data.Channel.map((item) => item.SID) : [];
    setFilterTemplate(finalFilterQuery);
    let sortEvent = gridSort[0] ?? initialSort;
    loaddata(
      { per_page: page.take, current_page: 1, orderby: sortEvent.field, direction: sortEvent.dir },
      data.SearchText,
      showArchived,
      finalFilterQuery,
      channelFilter
    )
  }

  const onEnterQuickEdit = (item) => {
    enterEdit({ ...item, quickEdit: true });
  }

  const onSortChange = (e) => {
    setGridSort(e.sort)
    let sortEvent = e.sort[0] ?? sort
    let current_page = page.skip / page.take + 1;
    loaddata(
      { per_page: page.take, current_page: current_page, orderby: sortEvent.field, direction: sortEvent.dir },
      searchText,
      showArchived,
      filterTemplate
    );
  }

  const onSearch = (e) => {
    e.preventDefault();
    let text = e.target.value?.trim();
    console.log("HERE")
    setSearchText(text);
    setFilterDataItem({ SearchText: text });
  };

  const onClearFilterTemplate = () => {
    setSelectedTemplate({});
    setFilterDataItem({});
    setIsFilterCleared(true);
    setSearchText('');
  }

  const onCloseUserPrefence = () => {
    let sortEvent = gridSort[0] ?? initialSort;
    loaddata({ per_page: page_take, current_page: 1, orderby: sortEvent.field, direction: sortEvent.dir }, searchText, showArchived, filterTemplate);
    setShowPreferences(!showPreferences);
  }

  const downloadExcel = async () => {

    let currentUserId = utility.getValue(LOCALSTORAGE_KEY.user_id);
    let columns = await API.getFormData(preferenceColumnENntityName, currentUserId);
    let dataRes = await API.getEntitiesSearchWithMediaGlobal(
      { query: ["MediaCategory.isLong", "=", true], page: null, current_page: null, archive: showArchived },
      columns,
      searchText,
      filterTemplate,
      props.mediaCategory,
      []
    );
    if (dataRes?.success && dataRes?.data?.length == 0) {
      ToastNotification({ type: TOAST_TYPES.INFO, title: lang.info_message_title, message: lang.no_data_found_error_message });
      return;
    }
    let res = await API.exportGridExcel(dataRes?.data, dataColumns, preferenceColumnENntityName);
    if (res.success) {
      window.open(FILEURL().BASEURL + 'downloadReport/' + res.data)
      ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.successfully_download_success_message });
    }
    else {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
    }
  }

  return (
    <div>
      {showTitle && (
        <h1 className="page-title txt-color-bludeDark">
          <i
            className="fa fa-table marlr"
            style={{ fontSize: "20px", color: "GrayText" }}
          ></i>
          <span>{myTitle === "" ? props.entityname : myTitle}</span>
        </h1>
      )}
      <div className="flex-container">
        <div className="martb mar">
          <BackRoundButton onClick={() => navigate(-1)}></BackRoundButton>
          {/* <RoundButton onClick={openFilterTemplate} title={lang.filter_template_tooltip} icon={"bars"} /> */}
        </div>

        <div className="flex-container-reverse flex-item-auto">
          <div className="input-group input-group w-300 martb" >
            <input
              type="text"
              className="form-control shadow-inset-2 pt-0 pb-0"
              id="searchInput"
              placeholder={lang.search_button_text}
              onChange={onSearch}
              onFocus={(e) => {
                if (props.setOutSideFocus) {
                  props.setOutSideFocus(true);
                }
              }}
              onBlur={(e) => {
                if (props.setOutSideFocus) {
                  props.setOutSideFocus(false);
                }
              }}
            />
            <button title="Advanced Search" style={{ border: "0px", backgroundColor: "white", height: "38px", marginTop: '-1px' }} onClick={() => setFilterPopupOpen(true)} aria-label="Advanced Search">
              <div className="input-group-append" >
                <span className="input-group-text" style={{ backgroundColor: !isFilterCleared ? "black" : "white" }}>
                  <i style={{ margin: "5px 0px", color: !isFilterCleared ? "white" : "black" }} className="fa fa-list" />
                </span>
              </div>
            </button>

          </div>
          <div className="mt-1 mr-1" style={{ paddingTop: "12px" }}>
            <RefreshButton onClick={refreshCollection} />
          </div>
          {showPreferenceButton && <div className="m-1" style={{ paddingTop: "12px" }}>
            <PreferenceRoundButton
              icon={"gear"}
              title={lang.preference_button_tooltip}
              onClick={() => { setShowPreferences(!showPreferences) }}
            />
          </div>}
          {showExport && (
            <div className="m-1" style={{ paddingTop: "12px" }}>
              <RoundButton
                icon={"download"}
                btnColor={"info"}
                style={{ color: 'white' }}
                title={lang.export_button_tooltip}
                onClick={downloadExcel}
              /></div>
          )}
          {!hideArchive && <div className="d-inline mt-3 mr-2">
            <input type='checkbox' name='FilteredArchive' checked={showArchived} onClick={onArchiveClick} onChange={() => { }} />  {lang.archive}
          </div>}
        </div>
      </div>
      {isLoading && <Loader />}

      {!isLoading &&
        <Grid
          data={gridData}
          style={props.gridstyle ?? {
            height: "76vh",
          }}
          ref={gridRef}
          sort={gridSort}
          sortable={sortable}
          onSortChange={onSortChange}
          rowRender={gridRowRender}
          filterable={filterable}
          pageable={isPageable}
          skip={page.skip}
          take={page.take}
          onPageChange={pageChange}
          total={total}
          resizable={true}

          dataItemKey={DATA_ITEM_KEY}
        >
          <GridNoRecords>{searchText && searchText.length == 0 && Object.keys(filterDataItem).length == 0 ? lang.please_select_filters_msg : lang.no_records_found}</GridNoRecords>

          {/* Edit Row */}
          {showCommandCell && (
            <GridColumn cell={MyCommandCell} width={"60px"} locked={true} resizable={false} />
          )}

          {/* Rows Loop */}
          {dataColumns.map((column, index) => {
            if (column.type === COLUMNSTYPE.date) {
              return (
                <GridColumn
                  key={index}
                  field={column.name}
                  cell={DateOnlyCell}
                  title={column.label}
                  width={column.width ?? 200}
                />
              );
              // }else if (column.name === COLUMNSTYPE.time) {
            } else if (column.type === COLUMNSTYPE.datetime) {
              return (
                <GridColumn
                  key={index}
                  field={column.name}
                  cell={DateCell}
                  title={column.label}
                  width={column.width ?? 200}
                />
              );
              // }else if (column.name === COLUMNSTYPE.time) {
            } else if (column.name.includes("Duration") || column.type == COLUMNSTYPE.time) {
              return (
                <GridColumn
                  key={index}
                  field={column.name}
                  cell={TimeCell}
                  title={column.label}
                  width={column.width ?? 200}
                />
              );
            } else if (column.name === "SID") {
              return;
              //we are not returning any value for SID column
            } else if (column.type === COLUMNSTYPE.image) {
              return (
                <GridColumn
                  sortable={false}
                  key={index}
                  field={column.name}
                  cell={ImageCell}
                  title={column.label}
                  width={column.width ?? 100}
                />
              );
            } else if (column.type === COLUMNSTYPE.select) {
              return (
                <GridColumn
                  sortable={false}
                  key={index}
                  field={column.name}
                  cell={MyDatalookupCell}
                  title={column.label}
                  width={column.width ?? 200}
                />
              );
            }
            else if (column.type === COLUMNSTYPE.toggle) {
              return (
                <GridColumn
                  sortable={false}
                  key={index}
                  field={column.name}
                  cell={MyCustomToggleButton}
                  title={column.label}
                  width={85}
                />
              );
            }
            else if (column.type === COLUMNSTYPE.checkbox) {
              return (
                <GridColumn
                  key={index}
                  field={column.name}
                  cell={CheckboxCell}
                  title={column.label}
                  width={column.width ?? 80}
                />
              );
            }
            else if (column.type === COLUMNSTYPE.array) {
              return (
                <GridColumn
                  sortable={false}
                  key={index}
                  field={column.name}
                  cell={ArrayCell}
                  title={column.label}
                  width={column.width ?? 200}
                  format={column.format ?? "Description"} //display item in object
                />
              );
            }
            else if (column.type === COLUMNSTYPE.href) {
              return (
                <GridColumn
                  sortable={false}
                  key={index}
                  field={column.name}
                  cell={HrefCell}
                  title={column.label}
                  width={column.width ?? 200}
                  format={column.format}
                />
              );
            }
            else if (column.type === COLUMNSTYPE.enum) {
              return (
                <GridColumn
                  key={index}
                  field={column.name}
                  cell={EnumCell}
                  title={column.label}
                  width={column.width ?? 200}
                  format={column.format ?? "Description"} //display item in object
                />
              );
            } else if (column.type === COLUMNSTYPE.platform) {
              return (
                <GridColumn
                  key={index}
                  field={column.name}
                  cell={PlatformCell}
                  title={column.label}
                  width={column.width ?? 200}
                />
              );
            }
            else if (column.type === COLUMNSTYPE.status) {
              return (
                <GridColumn
                  key={index}
                  field={column.name}
                  cell={Mystatuscell}
                  title={column.label}
                  width={column.width ?? 200}
                />
              );
            }
            else if (column.type === COLUMNSTYPE.transmission) {
              return (
                <GridColumn
                  key={index}
                  field={column.name}
                  cell={MyTransmissionCell}
                  title={column.label}
                  width={column.width ?? 200}
                />
              );
            }
            else if (column.type === COLUMNSTYPE.localdatetime) {
              return (
                <GridColumn
                  key={index}
                  field={column.name}
                  cell={LocalDateTimeColumn}
                  title={column.label}
                  width={column.width ?? 200}
                />
              );
            }
            else if (column.type === COLUMNSTYPE.icon) {
              return (
                <GridColumn
                  sortable={false}
                  key={index}
                  field={column.name}
                  cell={IconCell}
                  title={column.label}
                  width={column.width ?? 80}
                />
              );
            }
            else if (column.type === COLUMNSTYPE.arrayenum) {
              return (
                <GridColumn
                  key={index}
                  field={column.name}
                  cell={arrayEnumCell}
                  title={column.label}
                  width={column.width ?? 80}
                />
              );
            }
            else if (column.type === COLUMNSTYPE.castType) {
              return (
                <GridColumn
                  key={index}
                  field={column.name}
                  cell={castTypeCell}
                  title={column.label}
                  width={column.width ?? 80}
                />
              );
            }
            else {
              return (
                column.type !== COLUMNSTYPE.hidden && (
                  <GridColumn
                    key={index}
                    field={column.name}
                    title={column.label}
                    width={column.width ?? 200}
                  />
                )
              );
            }
          })}
        </Grid>}

      {filterPopupOpen &&
        <GlobalMediaFilterTemplate
          toGetFilteredData={toGetFilteredData}
          onClose={() => setFilterPopupOpen(false)}
          searchText={searchText}
          setSearchText={setSearchText}
          onSearch={onSearch}
          selectedTemplate={selectedTemplate}
          setSelectedTemplate={setSelectedTemplate}
          isFilterCleared={isFilterCleared}
          setIsFilterCleared={setIsFilterCleared}
          filterDataItem={filterDataItem}
          setFilterDataItem={setFilterDataItem}
          onClear={onClearFilterTemplate}
        />}
      {showPreferences && <UserPreference entityName={entityName} preferenceColumnENntityName={preferenceColumnENntityName} handleClose={onCloseUserPrefence} />}
    </div>
  );
};